module.exports = __webpack_public_path__ + "img/login_bg.bda07d22.png";